import React from 'react'
import { Navbar, Container, Nav, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { logOut } from '../../store/features/OTPSlice'
import { useNavigate } from 'react-router-dom';
import cookie from 'js-cookie'
import { List } from 'react-bootstrap-icons';
import './styles.css'
function Header() {
    let dispatch = useDispatch()
    let navigate = useNavigate()
    const { SPAJs } = useSelector((state) => state.SPAJs)
    const { DeviceId } = useSelector((state)=>state.DeviceId)
    const userAgent = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

    const goOut = (e) => {
        e.preventDefault()
        let data = {
            deviceid: `${DeviceId.deviceId}`,
            username: `${SPAJs.spajHeader?.userName}`,
            spajNumber: `${SPAJs.spajHeader?.spajNumber}`
        }
        dispatch(logOut(data)).then(res => {
            // if (res.status == "OK") {
            cookie.remove('accessToken');
            cookie.remove('refreshToken');
            localStorage.removeItem("SPAJ_HEADER");
            localStorage.removeItem("TOKEN");
            sessionStorage.removeItem('tokenPayment');
            navigate("/" + localStorage.getItem("spajHash"));
            // } else {
            // alert("error logout");
            // }
        }).catch(err => {
            return err
        })
    }
    return (
        <>
            <div style={{  zIndex: 999, width: '100%', top: 0, borderBottom: '1px solid #D8D8D8',}}>
                <Navbar bg="white" className='header-cont'>
                    <Container fluid>
                        <Navbar.Brand>
                            <img src="images/header2.png" width="250px" height="auto" />
                        </Navbar.Brand>
                        <Nav className="justify-content-end">
                            <Dropdown>
                                <Dropdown.Toggle className='button-list' id="dropdown-basic">
                                    <List color="#BC2C26" size={25} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={(e) => goOut(e)}>
                                        <button>Keluar</button>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Container>
                </Navbar>
            </div>
        </>
    )
}

export default Header